import { useCallback, useRef } from 'react'
import { lockScroll, unlockScroll } from '../scrollLock'

export const useScrollLock = () => {
  const scrollTopRef = useRef(0)

  const lock = useCallback(() => {
    scrollTopRef.current = lockScroll()
  }, [])

  const unlock = useCallback(() => {
    unlockScroll(scrollTopRef.current)
  }, [])

  return { lock, unlock }
}
